export default {
  superDesktop: 'Reports',
  home: 'Home',
  people: 'Contacts',
  opportunities: 'Opportunities',
  directory: 'CRM',
  lists: 'Lists',
  roles: 'Roles',
  segments: 'Segments',
  businesses: 'Companies',
  talk: 'Chat',
  chats: 'Chats',
  conversationMetrics: 'Metrics',
  conversationSettings: 'Chat configuration',
  emailSettings: 'Email configuration',
  communicate: 'Communicate',
  campaigns: 'Campaigns',
  triggers: 'Triggers',
  notifications: 'Notifications',
  connect: 'Connect',
  authenticator: 'Authenticator',
  forms: 'Forms',
  oAuths: 'Oauths',
  crm: 'CRM',
  /* events */
  events: 'Events',
  myEvents: 'My Events',
  categories: 'Categories',
  assistants: 'Assistants',
  promotors: 'Promotors',
  djs: 'Djs',
  productsCategories: 'Products Categories',
  products: 'Products',
  places: 'Places',
  productsSales: 'Products Sales',
  /* ORDERS */
  clients: 'Clients',
  colors: 'Colors',
  containerTypes: 'Container Types',
  purchases: 'Purchases',
  sellers: 'Sellers',
  suppliers: 'Suppliers',
  /* microsites */
  microSites: 'Micro sites',
  configure: 'Configure',
  generalities: 'Generalities',
  apps: 'Apps',
  administrators: 'Administrators',
  billing: 'Billing',
  graphicAspect: 'Graphic Aspect',
  automate: 'Automate',
  following: 'Following',
  mainTables: 'Main tables',
  panel: 'Panel',
  journeyLeads: 'Journey leads',
  sequences: 'Sequences',
  reachFrequency: 'Reach & Frequency',
  userConfiguration: 'User configuration'
}
